import React from 'react';
import { SiteContent } from 'components/common/styles';
import ContentLayout from 'components/ContentLayout';
import WHTransferErpProcess from 'components/Inventory/WarehouseTransferErpProcess';

const WarehouseTransferErpProcess = () => {
  return (
    <ContentLayout>
      <SiteContent>
        {/*<h1>Warehouse</h1>*/}
        <WHTransferErpProcess />
      </SiteContent>
    </ContentLayout>
  );
};

export default WarehouseTransferErpProcess;
